<template>
    <div>
        <p v-if="error" class="text-danger">{{ errorMsg }}</p>
        <b-card
            no-body
            class="overflow-hidden shadow-sm"
        >
            <b-table-simple 
                responsive
                class="base-data-card-table no-top-border cells-align-top"
            >
                <b-thead head-variant="light">
                    <b-tr>
                        <b-th colspan="2">
                            <div class="d-flex justify-content-between align-items-center">
                                <div>
                                    <span class="text-dark font-weight-bold">{{ heading }}</span>
                                </div>
                                <div>
                                    <slot name="action">
                                    </slot>
                                </div>
                            </div>
                        </b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <slot name="tbody">
                    <b-tr v-for="item in items" :key="`${item.label}-${item.value}`">
                        <b-th>{{ item.label }}</b-th>
                        <b-td>{{ item.value }}</b-td>
                    </b-tr>
                    </slot>
                </b-tbody>
            </b-table-simple>

        </b-card>
    </div>
</template>

<script>

export default {
    name: 'BaseDataCard',
    components: {},
    props: {
        heading: {
            type: String,
            required: false,
        },
        items: {  // should be array of Objects, with keys: 'label', 'value'
            type: Array,
            required: false,
        }
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            
        }
    },
    computed: {

    },
    methods: {
        handleError: function(error, message) {
            console.log(message);
            console.log(error);
            this.errorMsg = message;
            this.error = true;
        },

    }
}
</script>

<style lang="scss">

.base-data-card-table {
    margin-bottom: 0;

    tbody th {
        width: 25%;
        font-weight: 500;
        color: var(--gray-500);
    }
}

</style>